// frontend/src/components/CoinbaseAffiliate.js
// Coinbase affiliate link component
// Replace COINBASE_AFFILIATE_ID with your actual referral ID from:
// https://www.coinbase.com/affiliates

import React from 'react';

// Get your referral link from https://www.coinbase.com/affiliates
// Set REACT_APP_COINBASE_REFERRAL_URL in .env to your full referral URL
const COINBASE_URL = process.env.REACT_APP_COINBASE_REFERRAL_URL || 'https://www.coinbase.com/signup';

// Inline banner variant — hidden until affiliate ID is configured
const COINBASE_AFFILIATE_ENABLED = process.env.REACT_APP_COINBASE_ENABLED === 'true';

export const CoinbaseBanner = ({ style = {} }) => {
  if (!COINBASE_AFFILIATE_ENABLED) return null;
  return (
  <a
    href={COINBASE_URL}
    target="_blank"
    rel="noopener noreferrer sponsored"
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      background: 'linear-gradient(135deg, #0052ff 0%, #1a73e8 100%)',
      color: '#fff',
      borderRadius: '8px',
      padding: '12px 16px',
      textDecoration: 'none',
      fontSize: '14px',
      fontWeight: '600',
      boxShadow: '0 2px 8px rgba(0,82,255,0.3)',
      ...style
    }}
  >
    <span style={{ fontSize: '24px' }}>₿</span>
    <div>
      <div>Start trading crypto on Coinbase</div>
      <div style={{ fontSize: '12px', fontWeight: '400', opacity: 0.85 }}>
        Get $10 in Bitcoin when you buy $100+
      </div>
    </div>
    <span style={{ marginLeft: 'auto', fontSize: '18px' }}>→</span>
  </a>
  );
};

// Small inline text link variant
export const CoinbaseLink = ({ children }) => (
  <a
    href={COINBASE_URL}
    target="_blank"
    rel="noopener noreferrer sponsored"
    style={{ color: '#0052ff', fontWeight: '600' }}
  >
    {children || 'Buy on Coinbase'}
  </a>
);

export default CoinbaseBanner;
